import { VariablesContainer } from '@/modules/Variables/containers/VariablesContainer';

export const Variables = (): JSX.Element => <VariablesContainer />;

export default Variables;
